module.exports = __webpack_public_path__ + "img/conexo.9bdad2c6.jpg";